import dayjs from "dayjs";
import lodash from "lodash";
import update from "immutability-helper";
import { createSlice } from "@reduxjs/toolkit";
import { NOTIFICATION_PERMISSION_SETTED } from "../configuration";
import {
  ENCOUNTER_COLORE_CHANGED,
  ENCOUNTER_LUOGO_CHANGED,
  ENCOUNTER_OSPEDALE_CHANGED,
  ENCOUNTER_PRESTAZIONI_CHANGED,
  ENCOUNTER_STATO_CHANGED,
} from "../language";
import {
  azzeraMonitoraggio,
  fetchMonitoraggio,
  fetchMonitoraggioSuccess,
  fetchMonitoraggioFailed,
  fetchUpdateMonitoraggioSuccess,
  fetchUpdateMonitoraggioFailed,
  setEncounterNotification,
  resetEncounterNotification,
  closeEncounterNotification,
  setFailedEncounterCalls,
  LAST_UPDATE_TIMESTAMP,
  LAST_UPDATE_FORMAT,
  PS_CHANGED,
  STATO_PAZIENTE_CHANGED,
  CODICE_COLORE_CHANGED,
  POSIZIONE_CHANGED,
  PRESTAZIONI_CHANGED,
} from "./index";

export const initialState = {
  monitoraggio: {
    data: {},
    fetchEnded: false,
    updateNotification: null,
    openedNotification: {
      [PS_CHANGED]: [],
      [STATO_PAZIENTE_CHANGED]: [],
      [CODICE_COLORE_CHANGED]: [],
      [POSIZIONE_CHANGED]: [],
      [PRESTAZIONI_CHANGED]: {},
    },

    failedCalls: 0,
  },
};

const azzeraMonitoraggioHandler = (state) => {
  if (localStorage.getItem(NOTIFICATION_PERMISSION_SETTED) === "true") localStorage.setItem(NOTIFICATION_PERMISSION_SETTED, false);
  return update(state, {
    monitoraggio: { $set: initialState.monitoraggio },
  });
};

const fetchMonitoraggioHandler = (state) => {
  return update(state, {
    monitoraggio: {
      fetchEnded: { $set: false },
    },
  });
};

const fetchMonitoraggioSuccessHandler = (state, action) => {
  return update(state, {
    monitoraggio: {
      data: {
        $set: {
          ...action.payload,
          [LAST_UPDATE_TIMESTAMP]: dayjs().format(LAST_UPDATE_FORMAT),
        },
      },
      fetchEnded: { $set: true },
      failedCalls: { $set: initialState.monitoraggio.failedCalls },
    },
  });
};

const fetchMonitoraggioFailedHandler = (state) => {
  return update(state, {
    monitoraggio: {
      fetchEnded: { $set: true },
    },
  });
};

const fetchUpdateMonitoraggioSuccessHandler = (state, action) => {
  return update(state, {
    monitoraggio: {
      data: {
        $set: {
          ...state.monitoraggio.data,
          ...action.payload,
          [LAST_UPDATE_TIMESTAMP]: dayjs().format(LAST_UPDATE_FORMAT),
        },
      },
      fetchEnded: { $set: true },
      failedCalls: { $set: initialState.monitoraggio.failedCalls },
    },
  });
};

const fetchUpdateMonitoraggioFailedHandler = (state) => {
  return update(state, {
    monitoraggio: {
      fetchEnded: { $set: true },
    },
  });
};
const setEncounterNotificationHandler = (state, action) => {
  const { timestamp, changes, prestazioniChanges } = action.payload;
  const newState = lodash.cloneDeep(state.monitoraggio.openedNotification);
  if (changes.includes(ENCOUNTER_OSPEDALE_CHANGED)) newState[PS_CHANGED] = [timestamp.unix(), ...state.monitoraggio.openedNotification[PS_CHANGED]];
  if (changes.includes(ENCOUNTER_STATO_CHANGED)) newState[STATO_PAZIENTE_CHANGED] = [timestamp.unix(), ...state.monitoraggio.openedNotification[STATO_PAZIENTE_CHANGED]]; // prettier-ignore
  if (changes.includes(ENCOUNTER_COLORE_CHANGED)) newState[CODICE_COLORE_CHANGED] = [timestamp.unix(), ...state.monitoraggio.openedNotification[CODICE_COLORE_CHANGED]]; // prettier-ignore
  if (changes.includes(ENCOUNTER_LUOGO_CHANGED)) newState[POSIZIONE_CHANGED] = [timestamp.unix(), ...state.monitoraggio.openedNotification[POSIZIONE_CHANGED]]; // prettier-ignore
  if (changes.includes(ENCOUNTER_PRESTAZIONI_CHANGED)) newState[PRESTAZIONI_CHANGED][timestamp.unix()] = prestazioniChanges;

  return update(state, {
    monitoraggio: {
      updateNotification: { $set: action.payload },
      openedNotification: { $set: newState },
    },
  });
};

const resetEncounterNotificationHandler = (state) => {
  return update(state, {
    monitoraggio: {
      updateNotification: { $set: initialState.monitoraggio.updateNotification },
      openedNotification: { $set: initialState.monitoraggio.openedNotification },
    },
  });
};

const closeEncounterNotificationHandler = (state, action) => {
  const notificationId = action.payload;
  const newState = lodash.cloneDeep(state.monitoraggio.openedNotification);
  newState[PS_CHANGED] = state.monitoraggio.openedNotification[PS_CHANGED].indexOf(notificationId) === 0 ? [] : state.monitoraggio.openedNotification[PS_CHANGED].filter((id) => id !== notificationId); // prettier-ignore
  newState[STATO_PAZIENTE_CHANGED] = state.monitoraggio.openedNotification[STATO_PAZIENTE_CHANGED].indexOf(notificationId) === 0 ? [] : state.monitoraggio.openedNotification[STATO_PAZIENTE_CHANGED].filter((id) => id !== notificationId); // prettier-ignore
  newState[CODICE_COLORE_CHANGED] = state.monitoraggio.openedNotification[CODICE_COLORE_CHANGED].indexOf(notificationId) === 0 ? [] : state.monitoraggio.openedNotification[CODICE_COLORE_CHANGED].filter((id) => id !== notificationId); // prettier-ignore
  newState[POSIZIONE_CHANGED] = state.monitoraggio.openedNotification[POSIZIONE_CHANGED].indexOf(notificationId) === 0 ? [] : state.monitoraggio.openedNotification[POSIZIONE_CHANGED].filter((id) => id !== notificationId); // prettier-ignore
  delete newState[PRESTAZIONI_CHANGED][notificationId];

  return update(state, {
    monitoraggio: {
      openedNotification: { $set: newState },
    },
  });
};

const setFailedEncounterCallsHandler = (state, action) => {
  return update(state, {
    monitoraggio: {
      failedCalls: { $set: action.payload },
    },
  });
};

const trackingSlice = createSlice({
  name: "tracking",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(azzeraMonitoraggio, (state) => azzeraMonitoraggioHandler(state));
    builder.addCase(fetchMonitoraggio, (state) => fetchMonitoraggioHandler(state));
    builder.addCase(fetchMonitoraggioSuccess, (state, action) => fetchMonitoraggioSuccessHandler(state, action));
    builder.addCase(fetchMonitoraggioFailed, (state) => fetchMonitoraggioFailedHandler(state));
    builder.addCase(fetchUpdateMonitoraggioSuccess, (state, action) => fetchUpdateMonitoraggioSuccessHandler(state, action));
    builder.addCase(fetchUpdateMonitoraggioFailed, (state) => fetchUpdateMonitoraggioFailedHandler(state));
    builder.addCase(setEncounterNotification, (state, action) => setEncounterNotificationHandler(state, action));
    builder.addCase(resetEncounterNotification, (state) => resetEncounterNotificationHandler(state));
    builder.addCase(closeEncounterNotification, (state, action) => closeEncounterNotificationHandler(state, action));
    builder.addCase(setFailedEncounterCalls, (state, action) => setFailedEncounterCallsHandler(state, action));
  },
});

export const trackingReducer = trackingSlice.reducer;
